/**
 * Safely replaces a WASM object by freeing the old one and returning the new
 * one. Using this in an assignment like `this.field = replaceWasm(this.field, new Foo())`
 * ensures the constructor runs first (as a function argument) — if it throws,
 * the old object is never freed and the field retains its valid value.
 */
export function replaceWasm<T extends { free(): void }>(old: T | undefined | null, replacement: T): T {
  old?.free();
  return replacement;
}
